(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.Lengthy = factory());
}(this, (function () { 'use strict';

function Lengthy(els) {
  return $(els).map(function(el, i) {
    var length = getLength(el);
    el.classList.add("lengthy");
    el.style.setProperty("--path-length", length);
    return {
      el: el,
      length: length
    };
  });
}

function getValue(a) {
  return a.baseVal ? a.baseVal.value || a.baseVal : a;
}

function distance(x1, y1, x2, y2) {
  var dx = x1 - x2;
  var dy = y1 - y2;
  return Math.sqrt(dx * dx + dy * dy);
}

function getLength(el) {
  if (!el) {
    return false;
  }
  // <path> or any SVG element in SVG2 supporting browsers
  if (el.getTotalLength) {
    return el.getTotalLength();
  }
  // <use>
  if (el instanceof SVGUseElement) {
    return getLength(document.querySelector(getValue(el.href)));
  }
  // <rect>
  if (el.width) {
    return getValue(el.width) * 2 + getValue(el.height) * 2;
  }
  // <line>
  if (el.x1) {
    return distance(
      getValue(el.x1),
      getValue(el.y1),
      getValue(el.x2),
      getValue(el.y2)
    );
  }
  // <circle>
  if (el.r) {
    return 2 * Math.PI * getValue(el.r);
  }
  // <ellipse>
  if (el.rx && el.ry) {
    // Ramanujan ellipse circumference approximation
    // Thanks to https://twitter.com/jhnsnc
    var rx = getValue(el.rx);
    var ry = getValue(el.ry);
    return Math.PI * (3 * (rx + ry) - Math.sqrt((3 * rx + ry) * (rx + 3 * ry)));
  }
  // <polyline> and <polygon>
  if (el.points) {
    var p = el.getAttribute("points").split(/[\s,]+/);
    var d = 0,
      i = 0,
      l = p.length - 2;
    for (; i < l; i += 2) {
      d += distance(p[i], p[i + 1], p[i + 2], p[i + 3]);
    }
    if (el instanceof SVGPolygonElement) {
      d += distance(p[i], p[i + 1], p[0], p[1]);
    }
    return d;
  }
  return false;
}

Lengthy.getLength = getLength;

function $(els, parent) {
  return Array.prototype.slice.call(
    els.nodeName
      ? [els]
      : els[0].nodeName ? els : document.querySelectorAll(els),
    0
  );
}
Lengthy.$ = $;

return Lengthy;

})));



// ANIMATED SVG CIRCLES
// TOUCH OR NO-TOUCH, THAT IS THE QUESTION!
// SCROLL-TO ANIMATION FOR ANCHOR LINKS
// FADE-IN-UP ELEMENTS ON SCROLL
// SLIDER (SWIPER JS)
// SLIDER (SLICK JS)
// PRODUCT PICKER
// NEWSLETTER PICKER


//
// =RESPONSIVE VIDEO!
// --------------------------------------------------

// $(document).ready(loadVideo);
// $(window).on('resize',loadVideo);

// function loadVideo() {
//   var sm = window.matchMedia( "(min-width: 0px) and (max-width: 599px)" ), // Standard def (mp4, 640x360)
//       md = window.matchMedia( "(min-width: 600px) and (max-width: 899px)" ), // Standard def (mp4, 960x540)
//       lg = window.matchMedia( "(min-width: 900px) and (max-width: 1199px)" ), // High def (mp4, 1280x720)
//       xl = window.matchMedia( "(min-width: 1200px) and (max-width: 99999px)" ); // High def 1080 (mp4, 1920x1080)

//   sm.addListener($.proxy(changeVideoSize, this, 'sm'));
//   md.addListener($.proxy(changeVideoSize, this, 'md'));
//   lg.addListener($.proxy(changeVideoSize, this, 'lg'));
//   xl.addListener($.proxy(changeVideoSize, this, 'xl'));

//   if      (sm.matches) { changeVideoSize('sm') }
//   else if (md.matches) { changeVideoSize('md') }
//   else if (lg.matches) { changeVideoSize('lg') }
//   else if (xl.matches) { changeVideoSize('xl') }
// }

// function changeVideoSize(size){
//   var videoTag = $("#msdw-video-responsive")[0];
//   var videoSource = $("#msdw-video-responsive source");
//   videoSource.attr("src", videoSource.attr("data-video-"+size));
//   videoTag.autoplay = true;
//   videoTag.load();
//   console.log(videoSource.attr("src"));
// }

// var vid = document.getElementById("msdw-video-responsive");
// vid.onloadeddata = function() {
//   this.classList.add('msdw-video-loaded');
// };


//
// =ANIMATED SVG CIRCLES
// --------------------------------------------------

if (/Edge\/\d./i.test(navigator.userAgent)){
  document.body.classList.add('edge')
}

Lengthy('.msdw-path');


//
// =TOUCH OR NO-TOUCH, THAT IS THE QUESTION!
// --------------------------------------------------

// function isTouchDevice() {
//   return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
// }
// if (isTouchDevice() === true) {
//   $("body").toggleClass("touch");
// } else {
//   $("body").toggleClass("no-touch");
// }


//
// =SCROLL-TO ANIMATION FOR ANCHOR LINKS
// --------------------------------------------------

// $('.msdw-page-scroll').click(function() {
//   if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
//     var target = $(this.hash);
//     target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
//     if (target.length) {
//       var offsetValue = 0;
//       if ( window.innerWidth <= 767 ) {
//         offsetValue;
//         // console.log(offsetValue);
//       } else {
//         offsetValue = 59;
//         // console.log(offsetValue);
//       }

//       $('html,body').animate({
//         scrollTop: target.offset().top - offsetValue
//       }, 900);
//       return false;
//     }
//   }
// });


//
// =FADE-IN-UP ELEMENTS ON SCROLL
// --------------------------------------------------

const scroll = window.requestAnimationFrame;

function showOnScroll() {
  const elems = document.querySelectorAll('.msdw-animate');

  elems.forEach((el) => {
    const elPosition = el.getBoundingClientRect().top
    const elScreen = window.innerHeight / .9

    if (elPosition < elScreen) {
      el.classList.add('msdw-animated')
    }
  });

  scroll(showOnScroll);
}

showOnScroll();


//
// =SLIDER (SWIPER JS)
// --------------------------------------------------

const swiper = new Swiper('#sliderProducts', {
  slidesPerView: 1,
  loop: true,
  spaceBetween: 10,
  navigation: {
    nextEl: '.msdw-swiper-button-next',
    prevEl: '.msdw-swiper-button-prev',
  },
  breakpoints: {
    600: {
      slidesPerView: 2,
      spaceBetween: 15,
    },
    900: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  }
});





//
// =PRODUCT PICKER
// --------------------------------------------------

// $(".product-detail-picker").click(function(e){
//   e.preventDefault();
//   var productIdNumber = $(this).attr('data-product-id');
//   window.jwsdwMediator.publish('openPicker', 'productDetailPicker', {'productId': productIdNumber});
// });


//
// =NEWSLETTER PICKER
// --------------------------------------------------

// var campaignId = 'familyAndFriends',
//     pickerTag = document.getElementById("openPicker"),
//     newsletterConfig = {},
//     baseUrl = jwsdwSettings.baseUrl;

// $.ajax({
//   type: 'GET',
//   url: baseUrl + '/Newsletter-getNewsletterConfig',
//   data: {
//     campaignId: campaignId
//   },
//   success: function(response) {
//     newsletterConfig = response
//   },
//   error: function(response) {
//     jwsdwApi.popup.showHttpError(response.status)
//   }
// });

// pickerTag.addEventListener("click", function(){
//   window.jwsdwMediator.publish('openPicker', 'newsletterSignupPicker', {
//     "campaign": newsletterConfig.id,
//     "introduction": newsletterConfig.introduction,
//     "disclaimerOne": newsletterConfig.disclaimerOne,
//     "disclaimerTwo": newsletterConfig.disclaimerTwo
//   });
// });
